<template>
  <div class="ivan-setting-page anCore-fill" v-loading="loading">
    <div class="row">
      <div class="form-group col-sm-4">
        <div class="input-group">
          <span class="input-group-addon"><span>项目类型</span></span>
          <select class="form-control" v-model="basicFilter" @change="resetPage">
            <option value="">全部</option>
            <option v-for="b in basicOptions" :key="b" :value="b">{{ b }}</option>
          </select>
        </div>
      </div>
      <div class="form-group col-sm-4 has-feedback">
        <div class="input-group">
          <span class="input-group-addon"><span>项目因子</span></span>
          <input class="form-control" v-model="keyWord" @input="resetPage">
          <span class="fa fa-search form-control-feedback" aria-hidden="true" />
          <span class="sr-only">-</span>
        </div>
      </div>
    </div>

    <div class="table-area">
      <table class="table table-bordered table-condensed">
        <thead>
          <tr>
            <th style="min-width:120px;">项目因子名称</th>
            <th style="min-width:88px;">符号</th>
            <th style="min-width:120px;">别名/简称</th>
            <th style="min-width:150px;">项目类型</th>
            <th style="min-width:150px;">保存方法</th>
            <th style="min-width:150px;">采样难度系数</th>
            <th style="min-width:150px;">检测难度系数</th>
            <th style="min-width:150px;">现场值字段</th>
            <th style="width:110px;text-align:center;">
              <button type="button" class="btn btn-success btn-sm" @click="onReadonly">
                <i class="fa fa-plus" />&nbsp;新增
              </button>
            </th>
          </tr>
        </thead>
        <tbody v-if="pageRows.length">
          <tr
            v-for="row in pageRows"
            :key="row.ItemID"
            :class="{ 'anCore-item-active': selectedId === row.ItemID }"
            @click="selectRow(row.ItemID)"
          >
            <td>{{ row.ItemName }}</td>
            <td><span>{{ row.Symbol }}</span></td>
            <td>{{ row.OtherItemName }}</td>
            <td>{{ row.InspectBasicType }}</td>
            <td class="text-muted">
              <div v-if="row.PickSaveMethod">现场固定：{{ row.PickSaveMethod }}</div>
              <div v-if="row.LabSaveMethod">实验室保存：{{ row.LabSaveMethod }}</div>
            </td>
            <td>{{ empty(row.PickPerfGrade) }}</td>
            <td>{{ empty(row.LabPerfGrade) }}</td>
            <td class="text-muted">{{ row.LiveValueField || '' }}</td>
            <td>
              <button type="button" class="btn btn-link btn-sm" title="编辑" @click.stop="onReadonly">
                <i class="fa fa-edit" />
              </button>
              <button type="button" class="btn btn-link btn-sm" title="删除" @click.stop="onReadonly">
                <i class="fa fa-trash-o text-muted" />
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9">
              <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
            </td>
          </tr>
        </tbody>
      </table>
      <ivan-pager :page-index.sync="pageIndex" :page-count="pageCount" @change="selectedId = null" />
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'
import ivanSettingList from '@/mixins/ivanSettingList'
import IvanPager from '@/components/ivan/IvanPager.vue'

const PAGE_SIZE = 15

export default {
  name: 'ItemFactorSetting',
  components: { IvanPager },
  mixins: [ivanSettingList],
  data() {
    return {
      loading: false,
      list: [],
      basicOptions: [],
      basicFilter: '',
      keyWord: ''
    }
  },
  computed: {
    filtered() {
      const kw = String(this.keyWord || '').trim().toLowerCase()
      return this.list.filter(row => {
        if (this.basicFilter && row.InspectBasicType !== this.basicFilter) return false
        if (!kw) return true
        const hay = [row.ItemName, row.Symbol, row.OtherItemName, row.InspectBasicType]
          .map(x => String(x || '').toLowerCase())
          .join(' ')
        return hay.indexOf(kw) >= 0
      })
    },
    pageCount() {
      return this.calcPageCount(this.filtered.length, PAGE_SIZE)
    },
    pageRows() {
      return this.pageSlice(this.filtered, PAGE_SIZE)
    }
  },
  created() {
    this.load()
  },
  methods: {
    empty(v) {
      return v == null ? '' : v
    },
    async load() {
      this.loading = true
      try {
        const data = await loadIvanSyncJson('item_factor.json')
        this.list = (data && data.dataGrid && data.dataGrid.List) || []
        this.basicOptions = (data.basicTypeList || []).map(b => b.InspectBasicType).filter(Boolean)
        if (!this.basicOptions.length) {
          const set = {}
          this.list.forEach(r => {
            if (r.InspectBasicType) set[r.InspectBasicType] = true
          })
          this.basicOptions = Object.keys(set)
        }
      } catch (e) {
        this.$message.error(e.message || '加载项目因子失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ivan-setting-page {
  height: 100%;
  padding: 8px 12px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ivan-setting-page > .row { margin: 0; flex: 0 0 auto; }
.table-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  height: calc(100% - 60px);
}
.table-area >>> tbody tr { cursor: pointer; }
.has-feedback .form-control-feedback {
  pointer-events: none;
  z-index: 3;
  right: 0;
  line-height: 34px;
  height: 34px;
}
</style>
